// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-bg {
  background: url('home_background_mobile.png') no-repeat center center fixed;
  background-size: cover;
  width: auto;
  height: 100%;
}

.header-row {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 991px) {
  .header-row {
    height: 127px;
    padding-inline: 50px;
  }
}
.header-row .logo {
  display: none;
}
@media (min-width: 991px) {
  .header-row .logo {
    display: block;
    height: 58px;
    width: 291px;
  }
}
.header-row app-burger-btn {
  margin-left: auto;
  --icon-color: var(--ion-color-primary);
}
@media (height < 770px) {
  .header-row app-burger-btn {
    margin-right: 10px;
  }
}

.content-row {
  height: 100%;
}
.content-row .content-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 35px 50%;
}

.brand-logo {
  height: 95px;
  width: 100%;
  margin-bottom: 70px;
}
@media (height < 770px) {
  .brand-logo {
    height: 60px;
    margin-bottom: 25px;
  }
}
@media (min-width: 991px) {
  .brand-logo {
    display: none;
    height: 45px;
  }
}

.card {
  background: var(--color-white);
  padding: 42px 20px 30px;
  margin: 0 auto;
  overflow: hidden;
  min-width: 300px;
  width: 100%;
  max-width: 375px;
  border: 1px solid #000000;
  border-radius: var(--radius-default);
}
@media (height < 770px) {
  .card {
    padding: 12px;
  }
}
.card .overlay {
  padding-bottom: 20px;
  padding-top: 0px;
  border-bottom: 0.5px solid #939393;
  margin-bottom: 16px;
}
.card .overlay .pie-img {
  width: 100%;
  max-width: 165px;
  margin: 0px auto 0px;
  height: auto;
}
@media (height < 770px) {
  .card .overlay .pie-img {
    padding: 0;
    width: 100%;
    max-width: 165px;
    margin: 0px auto;
    height: 80px;
  }
}
.card .button-wrap {
  text-align: center;
  cursor: pointer;
  padding-top: 15px;
}
.card .button-wrap .btn span {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: capitalize;
  color: var(--color-white);
}
.card .button-wrap .btn ion-spinner {
  color: var(--color-white);
}

ion-footer {
  --background: transparent;
  background: transparent;
  overflow: hidden;
  position: absolute;
  bottom: 0;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: max-content;
  margin: 0 auto;
  gap: 10px;
}
.footer-lang div {
  text-align: center;
  border: 0.5px solid #0f0f0e;
  background: #3c3c3b;
  border-radius: var(--radius-default);
  overflow: hidden;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  gap: 10px;
}
.footer-lang div p {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
}
.footer-lang div ion-icon {
  height: 13px;
  width: 20px;
}
.footer-lang div.selected {
  background: #ffffff;
}
.footer-lang div.selected p {
  color: var(--color-black);
}

.lang-block {
  padding-bottom: 25px;
}

.info-text {
  color: var(--color-black);
  font-family: AppFont;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  vertical-align: middle;
  text-wrap: balance;
  margin-bottom: 10px;
}

.overlay-payment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 18px;
  border-top: 0.5px solid #939393;
  border-bottom: 0.5px solid #939393;
}
.overlay-payment .info-payment {
  font-family: AppFont;
  font-weight: 400;
  font-size: 10px;
  line-height: 150%;
  letter-spacing: -0.03em;
  text-align: center;
  margin-bottom: 10px;
}
.overlay-payment .payment-icons {
  width: 100%;
  height: 16px;
}

.alergen-link {
  padding-top: 20px;
  cursor: pointer;
  color: #3c3c3b;
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 1px;
}

.select-preorder-container {
  padding-bottom: 20px;
}
.select-preorder-container p {
  padding: 20px;
  font-family: AppFont;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  vertical-align: middle;
}
.select-preorder-container ion-col.take_away {
  padding-left: 5px;
}
.select-preorder-container ion-col.take_away .select-preorder-img {
  padding: 30px 0;
}
.select-preorder-container ion-col.inside {
  padding-right: 5px;
}
.select-preorder-container ion-col .select-preorder-img {
  display: flex;
  justify-content: center;
  padding: 40px 0;
  border: 0.5px solid #939393;
  border-bottom: none;
}
.select-preorder-container ion-col ion-button {
  color: var(--color-black);
  font-family: AppFont;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  text-transform: capitalize;
  letter-spacing: 0.1px;
  border-radius: 1px;
}

.title {
  padding-block: 15px;
  width: 70%;
  margin: 0 auto;
  font-family: AppFont;
  font-size: 16px;
  line-height: 115%;
  letter-spacing: 0;
  text-align: center;
  color: #3c3c3b;
}

.subtitle {
  display: block;
  font-family: AppFontSemiBold;
  font-size: 24px;
  color: #1d1d1b;
  text-wrap: balance;
  margin-bottom: 10px;
}
@media (height < 770px) {
  .subtitle {
    font-size: 12px;
  }
}

.preorder-title {
  font-family: AppFont;
  font-size: 16px;
  font-weight: 500;
  color: #1d1d1b;
}
@media (height < 770px) {
  .preorder-title {
    font-size: 14px;
  }
}

@media (height < 770px) {
  .btn {
    height: 40px !important;
  }
}

.pointer {
  cursor: pointer;
}

.inputs-block {
  width: 80%;
  margin: 0 auto;
}

.input-block {
  position: relative;
  width: 100%;
  margin: 0 auto 12px;
}
.input-block ion-label {
  position: absolute;
  top: 3px;
  left: 50%;
  transform: translate(-50%, 0%);
  font-family: AppFont;
  font-size: 9px;
  line-height: 150%;
  letter-spacing: 0.01em;
  width: max-content;
  color: #4d5053;
}

ion-item {
  border: 0.8px solid #a2834f;
  border-radius: 3px;
  --background: transparent !important;
  --min-height: 30px;
  --inner-padding-end: 0;
}
ion-item.input-error {
  border: 0.8px solid #cc0e0e;
}
ion-item ion-input {
  font-family: AppFontMedium, sans-serif;
  font-size: 13px;
  line-height: 127%;
  letter-spacing: 0.01em;
  color: var(--color-black);
  text-align: center !important;
  --padding-top: 1px;
  min-height: 35px;
}
ion-item ion-input ion-label {
  align-self: center;
}
ion-item:has(ion-checkbox) {
  border: none;
}
ion-item .input-error {
  border: 0.8px solid #cc0e0e;
}

.error-text-block {
  position: absolute;
  left: 0;
  bottom: -13px;
  width: max-content;
}
.error-text-block .error-text {
  font-family: AppFont;
  font-size: 8px;
  line-height: 135%;
  letter-spacing: 0;
  vertical-align: middle;
  margin: 0;
}

.privacy-checkbox .checkbox-label {
  margin: 0;
  font-family: AppFont;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0em;
  text-align: left;
  color: var(--color-black);
}
.privacy-checkbox ion-checkbox {
  height: 20px;
  --checkmark-color: #fff;
  --border-color: #939393;
  --border-width: 1px;
  margin: 0;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,2EAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AADD;;AAGA;EACC,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAD;ACXE;EDOF;IAME,aAAA;IACA,oBAAA;EAEA;AACF;AAAC;EACC,aAAA;AAEF;ACpBE;EDiBD;IAGE,cAAA;IACA,YAAA;IACA,YAAA;EAID;AACF;AADC;EACC,iBAAA;EACA,sCAAA;AAGF;AADE;EAJD;IAKE,kBAAA;EAID;AACF;;AAAA;EACC,YAAA;AAGD;AADC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAGF;;AACA;EACC,YAAA;EACA,WAAA;EACA,mBAAA;AAED;AAAC;EALD;IAME,YAAA;IACA,mBAAA;EAGA;AACF;AC3DE;EDgDF;IAWE,aAAA;IACA,YAAA;EAIA;AACF;;AADA;EACC,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,oCAAA;AAID;AAFC;EAXD;IAYE,aAAA;EAKA;AACF;AAHC;EACC,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;AAKF;AAHE;EACC,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;AAKH;AAHG;EAND;IAOE,UAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;EAMF;AACF;AAFC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;AAIF;AAFG;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EAEA,yBAAA;AAGJ;AAAG;EACC,yBAAA;AAEJ;;AAIA;EACC,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AADD;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAAD;AAEC;EACC,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,SAAA;AAAF;AACE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,yBAAA;AAAH;AAEE;EACC,YAAA;EACA,WAAA;AAAH;AAIE;EACC,mBAAA;AAFH;AAIG;EACC,yBAAA;AAFJ;;AAQA;EACC,oBAAA;AALD;;AAQA;EACC,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;AAND;;AASA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kCAAA;AAND;AAQC;EACC,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AANF;AAQC;EACC,WAAA;EACA,YAAA;AANF;;AASA;EACC,iBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,8BAAA;AAND;;AASA;EACC,oBAAA;AAND;AAOC;EACC,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AALF;AAQE;EACC,iBAAA;AANH;AAOG;EACC,eAAA;AALJ;AAQE;EACC,kBAAA;AANH;AAQE;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AANH;AAQE;EACC,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;AANH;;AAWA;EACC,mBAAA;EACA,UAAA;EACA,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,cAAA;AAVD;;AAaA;EACC,cAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAVD;AAYC;EARD;IASE,eAAA;EATA;AACF;;AAYA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATD;AAWC;EAND;IAOE,eAAA;EARA;AACF;;AAYC;EADD;IAEE,uBAAA;EARA;AACF;;AAWA;EACC,eAAA;AARD;;AAWA;EACC,UAAA;EACA,cAAA;AARD;;AAWA;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;AARD;AAUC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,cAAA;AATF;;AAaA;EACC,2BAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,sBAAA;AAVD;AAYC;EACC,2BAAA;AAVF;AAaC;EACC,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,6BAAA;EAGA,kBAAA;EACA,gBAAA;AAbF;AAeE;EACC,kBAAA;AAbH;AAoBC;EACC,YAAA;AAlBF;AAoBC;EACC,2BAAA;AAlBF;;AAsBA;EACC,kBAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;AAnBD;AAqBC;EACC,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;AAnBF;;AAwBC;EACC,SAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAtBF;AAyBC;EACC,YAAA;EAEA,uBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,SAAA;EACA,kBAAA;AAzBF","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.home-bg {\n\tbackground: url('../../../assets/heineken/home_background_mobile.png') no-repeat center center fixed;\n\tbackground-size: cover;\n\twidth: auto;\n\theight: 100%;\n}\n.header-row {\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\t@include desktop {\n\t\theight: 127px;\n\t\tpadding-inline: 50px;\n\t}\n\n\t.logo {\n\t\tdisplay: none;\n\t\t@include desktop {\n\t\t\tdisplay: block;\n\t\t\theight: 58px;\n\t\t\twidth: 291px;\n\t\t}\n\t}\n\n\tapp-burger-btn {\n\t\tmargin-left: auto;\n\t\t--icon-color: var(--ion-color-primary);\n\n\t\t@media (height < 770px) {\n\t\t\tmargin-right: 10px;\n\t\t}\n\t}\n}\n\n.content-row {\n\theight: 100%;\n\n\t.content-col {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 0 35px 50%;\n\t}\n}\n\n.brand-logo {\n\theight: 95px;\n\twidth: 100%;\n\tmargin-bottom: 70px;\n\n\t@media (height < 770px) {\n\t\theight: 60px;\n\t\tmargin-bottom: 25px;\n\t}\n\n\t@include desktop {\n\t\tdisplay: none;\n\t\theight: 45px;\n\t}\n}\n\n.card {\n\tbackground: var(--color-white);\n\tpadding: 42px 20px 30px;\n\tmargin: 0 auto;\n\toverflow: hidden;\n\tmin-width: 300px;\n\twidth: 100%;\n\tmax-width: 375px;\n\tborder: 1px solid #000000;\n\tborder-radius: var(--radius-default);\n\n\t@media (height < 770px) {\n\t\tpadding: 12px;\n\t}\n\n\t.overlay {\n\t\tpadding-bottom: 20px;\n\t\tpadding-top: 0px;\n\t\tborder-bottom: 0.5px solid #939393;\n\t\tmargin-bottom: 16px;\n\n\t\t.pie-img {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 165px;\n\t\t\tmargin: 0px auto 0px;\n\t\t\theight: auto;\n\n\t\t\t@media (height < 770px) {\n\t\t\t\tpadding: 0;\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 165px;\n\t\t\t\tmargin: 0px auto;\n\t\t\t\theight: 80px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.button-wrap {\n\t\ttext-align: center;\n\t\tcursor: pointer;\n\t\tpadding-top: 15px;\n\t\t.btn {\n\t\t\tspan {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 135%;\n\t\t\t\tletter-spacing: 0.02em;\n\t\t\t\ttext-align: center;\n\t\t\t\ttext-transform: capitalize;\n\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\n\t\t\tion-spinner {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n\nion-footer {\n\t--background: transparent;\n\tbackground: transparent;\n\toverflow: hidden;\n\tposition: absolute;\n\tbottom: 0;\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmax-width: max-content;\n\tmargin: 0 auto;\n\tgap: 10px;\n\n\tdiv {\n\t\ttext-align: center;\n\t\tborder: 0.5px solid #0f0f0e;\n\t\tbackground: #3c3c3b;\n\t\tborder-radius: var(--radius-default);\n\t\toverflow: hidden;\n\t\tpadding: 10px 16px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: fit-content;\n\t\tgap: 10px;\n\t\tp {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t\tion-icon {\n\t\t\theight: 13px;\n\t\t\twidth: 20px;\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tbackground: #ffffff;\n\n\t\t\tp {\n\t\t\t\tcolor: var(--color-black);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.lang-block {\n\tpadding-bottom: 25px;\n}\n\n.info-text {\n\tcolor: var(--color-black);\n\tfont-family: AppFont;\n\tfont-weight: 400;\n\tfont-size: 14px;\n\tline-height: 135%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-wrap: balance;\n\n\tmargin-bottom: 10px;\n}\n\n.overlay-payment {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 10px;\n\tpadding-bottom: 18px;\n\tborder-top: 0.5px solid #939393;\n\tborder-bottom: 0.5px solid #939393;\n\n\t.info-payment {\n\t\tfont-family: AppFont;\n\t\tfont-weight: 400;\n\t\tfont-size: 10px;\n\t\tline-height: 150%;\n\t\tletter-spacing: -0.03em;\n\t\ttext-align: center;\n\t\tmargin-bottom: 10px;\n\t}\n\t.payment-icons {\n\t\twidth: 100%;\n\t\theight: 16px;\n\t}\n}\n.alergen-link {\n\tpadding-top: 20px;\n\tcursor: pointer;\n\tcolor: #3c3c3b;\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 135%;\n\tletter-spacing: 0.01em;\n\ttext-align: center;\n\ttext-decoration: underline;\n\ttext-decoration-style: solid;\n\ttext-decoration-offset: 0%;\n\ttext-decoration-thickness: 1px;\n}\n\n.select-preorder-container {\n\tpadding-bottom: 20px;\n\tp {\n\t\tpadding: 20px;\n\t\tfont-family: AppFont;\n\t\tfont-weight: 500;\n\t\tfont-size: 16px;\n\t\tline-height: 100%;\n\t\tvertical-align: middle;\n\t}\n\tion-col {\n\t\t&.take_away {\n\t\t\tpadding-left: 5px;\n\t\t\t.select-preorder-img {\n\t\t\t\tpadding: 30px 0;\n\t\t\t}\n\t\t}\n\t\t&.inside {\n\t\t\tpadding-right: 5px;\n\t\t}\n\t\t.select-preorder-img {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\tpadding: 40px 0;\n\t\t\tborder: 0.5px solid #939393;\n\t\t\tborder-bottom: none;\n\t\t}\n\t\tion-button {\n\t\t\tcolor: var(--color-black);\n\t\t\tfont-family: AppFont;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 135%;\n\t\t\ttext-transform: capitalize;\n\t\t\tletter-spacing: 0.1px;\n\t\t\tborder-radius: 1px;\n\t\t}\n\t}\n}\n\n.title {\n\tpadding-block: 15px;\n\twidth: 70%;\n\tmargin: 0 auto;\n\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 115%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\n\tcolor: #3c3c3b;\n}\n\n.subtitle {\n\tdisplay: block;\n\tfont-family: AppFontSemiBold;\n\tfont-size: 24px;\n\tcolor: #1d1d1b;\n\ttext-wrap: balance;\n\tmargin-bottom: 10px;\n\n\t@media (height < 770px) {\n\t\tfont-size: 12px;\n\t}\n}\n\n.preorder-title {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: #1d1d1b;\n\n\t@media (height < 770px) {\n\t\tfont-size: 14px;\n\t}\n}\n\n.btn {\n\t@media (height < 770px) {\n\t\theight: 40px !important;\n\t}\n}\n\n.pointer {\n\tcursor: pointer;\n}\n\n.inputs-block {\n\twidth: 80%;\n\tmargin: 0 auto;\n}\n\n.input-block {\n\tposition: relative;\n\twidth: 100%;\n\tmargin: 0 auto 12px;\n\n\tion-label {\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, 0%);\n\t\tfont-family: AppFont;\n\t\tfont-size: 9px;\n\t\tline-height: 150%;\n\t\tletter-spacing: 0.01em;\n\t\twidth: max-content;\n\n\t\tcolor: #4d5053;\n\t}\n}\n\nion-item {\n\tborder: 0.8px solid #a2834f;\n\tborder-radius: 3px;\n\t--background: transparent !important;\n\t--min-height: 30px;\n\t--inner-padding-end: 0;\n\n\t&.input-error {\n\t\tborder: 0.8px solid #cc0e0e;\n\t}\n\n\tion-input {\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 13px;\n\t\tline-height: 127%;\n\t\tletter-spacing: 0.01em;\n\t\tcolor: var(--color-black);\n\t\ttext-align: center !important;\n\n\t\t// --padding-start: 14px;\n\t\t--padding-top: 1px;\n\t\tmin-height: 35px;\n\n\t\tion-label {\n\t\t\talign-self: center;\n\t\t}\n\t}\n\n\t&:not(:has(ion-checkbox)) {\n\t}\n\n\t&:has(ion-checkbox) {\n\t\tborder: none;\n\t}\n\t.input-error {\n\t\tborder: 0.8px solid #cc0e0e;\n\t}\n}\n\n.error-text-block {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: -13px;\n\twidth: max-content;\n\n\t.error-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 8px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\tvertical-align: middle;\n\t\tmargin: 0;\n\t}\n}\n\n.privacy-checkbox {\n\t.checkbox-label {\n\t\tmargin: 0;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: var(--color-black);\n\t}\n\n\tion-checkbox {\n\t\theight: 20px;\n\t\t// margin-top: -3px;\n\t\t--checkmark-color: #fff;\n\t\t--border-color: #939393;\n\t\t--border-width: 1px;\n\n\t\tmargin: 0;\n\t\tmargin-right: 10px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
